// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/insights.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
import { GrantReason } from "../../app/v1/app_entitlement_user_binding_reasons";
import { UserAttributeMappingSource } from "../../user/v1/user";
import { Outcome } from "../../analysis/v1/analysis";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { UserStatus } from "../../user/v1/user";
/**
 * @generated from protobuf message c1.api.task.v1.Insight
 */
export interface Insight {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string ticket_id = 2;
     */
    ticketId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.InsightType type = 3;
     */
    type: InsightType;
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "cost";
        /**
         * @generated from protobuf field: c1.api.task.v1.CostInsight cost = 100;
         */
        cost: CostInsight;
    } | {
        oneofKind: "userStatus";
        /**
         * @generated from protobuf field: c1.api.task.v1.UserStatusInsight user_status = 101;
         */
        userStatus: UserStatusInsight;
    } | {
        oneofKind: "usage";
        /**
         * @generated from protobuf field: c1.api.task.v1.UsageInsight usage = 102;
         */
        usage: UsageInsight;
    } | {
        oneofKind: "risk";
        /**
         * @generated from protobuf field: c1.api.task.v1.RiskInsight risk = 103;
         */
        risk: RiskInsight;
    } | {
        oneofKind: "analysis";
        /**
         * @generated from protobuf field: c1.api.task.v1.AnalysisInsight analysis = 104;
         */
        analysis: AnalysisInsight;
    } | {
        oneofKind: "employmentStatus";
        /**
         * @generated from protobuf field: c1.api.task.v1.EmploymentStatusInsight employment_status = 105;
         */
        employmentStatus: EmploymentStatusInsight;
    } | {
        oneofKind: "complianceFramework";
        /**
         * @generated from protobuf field: c1.api.task.v1.ComplianceFrameworkInsight compliance_framework = 106;
         */
        complianceFramework: ComplianceFrameworkInsight;
    } | {
        oneofKind: "grantOrigin";
        /**
         * @generated from protobuf field: c1.api.task.v1.GrantOriginInsight grant_origin = 107;
         */
        grantOrigin: GrantOriginInsight;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.task.v1.CostInsight
 */
export interface CostInsight {
    /**
     * @generated from protobuf field: int32 monthly_cost_usd = 1;
     */
    monthlyCostUsd: number;
}
/**
 * @generated from protobuf message c1.api.task.v1.UserStatusInsight
 */
export interface UserStatusInsight {
    /**
     * @generated from protobuf field: c1.api.user.v1.UserStatus user_status = 1;
     */
    userStatus: UserStatus;
}
/**
 * @generated from protobuf message c1.api.task.v1.UsageInsight
 */
export interface UsageInsight {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 1;
     */
    lastUsedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.task.v1.RiskInsight
 */
export interface RiskInsight {
    /**
     * @generated from protobuf field: string risk_level_value_id = 1;
     */
    riskLevelValueId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.AnalysisInsight
 */
export interface AnalysisInsight {
    /**
     * @generated from protobuf field: c1.api.analysis.v1.Outcome outcome = 2;
     */
    outcome?: Outcome;
}
/**
 * @generated from protobuf message c1.api.task.v1.EmploymentStatusInsight
 */
export interface EmploymentStatusInsight {
    /**
     * @generated from protobuf field: string employment_status = 1;
     */
    employmentStatus: string;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserAttributeMappingSource employment_status_sources = 2;
     */
    employmentStatusSources: UserAttributeMappingSource[];
}
/**
 * @generated from protobuf message c1.api.task.v1.ComplianceFrameworkInsight
 */
export interface ComplianceFrameworkInsight {
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 1;
     */
    complianceFrameworkIds: string[];
}
/**
 * @generated from protobuf message c1.api.task.v1.GrantOriginInsight
 */
export interface GrantOriginInsight {
    /**
     * @generated from protobuf field: c1.api.app.v1.GrantReason grant_reason = 1;
     */
    grantReason?: GrantReason;
}
/**
 * @generated from protobuf enum c1.api.task.v1.InsightType
 */
export enum InsightType {
    /**
     * @generated from protobuf enum value: INSIGHT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INSIGHT_TYPE_NEUTRAL = 1;
     */
    NEUTRAL = 1,
    /**
     * @generated from protobuf enum value: INSIGHT_TYPE_POSITIVE = 2;
     */
    POSITIVE = 2,
    /**
     * @generated from protobuf enum value: INSIGHT_TYPE_NEGATIVE = 3;
     */
    NEGATIVE = 3,
    /**
     * @generated from protobuf enum value: INSIGHT_TYPE_ALERT = 4;
     */
    ALERT = 4
}
/**
 * @generated from protobuf enum c1.api.task.v1.InsightRecommendation
 */
export enum InsightRecommendation {
    /**
     * @generated from protobuf enum value: INSIGHT_RECOMMENDATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: INSIGHT_RECOMMENDATION_APPROVE = 1;
     */
    APPROVE = 1,
    /**
     * @generated from protobuf enum value: INSIGHT_RECOMMENDATION_DENY = 2;
     */
    DENY = 2,
    /**
     * @generated from protobuf enum value: INSIGHT_RECOMMENDATION_REVIEW = 3;
     */
    REVIEW = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Insight$Type extends MessageType<Insight> {
    constructor() {
        super("c1.api.task.v1.Insight", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["c1.api.task.v1.InsightType", InsightType, "INSIGHT_TYPE_"] },
            { no: 100, name: "cost", kind: "message", oneof: "kind", T: () => CostInsight },
            { no: 101, name: "user_status", kind: "message", oneof: "kind", T: () => UserStatusInsight },
            { no: 102, name: "usage", kind: "message", oneof: "kind", T: () => UsageInsight },
            { no: 103, name: "risk", kind: "message", oneof: "kind", T: () => RiskInsight },
            { no: 104, name: "analysis", kind: "message", oneof: "kind", T: () => AnalysisInsight },
            { no: 105, name: "employment_status", kind: "message", oneof: "kind", T: () => EmploymentStatusInsight },
            { no: 106, name: "compliance_framework", kind: "message", oneof: "kind", T: () => ComplianceFrameworkInsight },
            { no: 107, name: "grant_origin", kind: "message", oneof: "kind", T: () => GrantOriginInsight }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.Insight
 */
export const Insight = new Insight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostInsight$Type extends MessageType<CostInsight> {
    constructor() {
        super("c1.api.task.v1.CostInsight", [
            { no: 1, name: "monthly_cost_usd", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CostInsight
 */
export const CostInsight = new CostInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserStatusInsight$Type extends MessageType<UserStatusInsight> {
    constructor() {
        super("c1.api.task.v1.UserStatusInsight", [
            { no: 1, name: "user_status", kind: "enum", T: () => ["c1.api.user.v1.UserStatus", UserStatus] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.UserStatusInsight
 */
export const UserStatusInsight = new UserStatusInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UsageInsight$Type extends MessageType<UsageInsight> {
    constructor() {
        super("c1.api.task.v1.UsageInsight", [
            { no: 1, name: "last_used_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.UsageInsight
 */
export const UsageInsight = new UsageInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RiskInsight$Type extends MessageType<RiskInsight> {
    constructor() {
        super("c1.api.task.v1.RiskInsight", [
            { no: 1, name: "risk_level_value_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.RiskInsight
 */
export const RiskInsight = new RiskInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnalysisInsight$Type extends MessageType<AnalysisInsight> {
    constructor() {
        super("c1.api.task.v1.AnalysisInsight", [
            { no: 2, name: "outcome", kind: "message", T: () => Outcome }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.AnalysisInsight
 */
export const AnalysisInsight = new AnalysisInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmploymentStatusInsight$Type extends MessageType<EmploymentStatusInsight> {
    constructor() {
        super("c1.api.task.v1.EmploymentStatusInsight", [
            { no: 1, name: "employment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "employment_status_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAttributeMappingSource }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.EmploymentStatusInsight
 */
export const EmploymentStatusInsight = new EmploymentStatusInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ComplianceFrameworkInsight$Type extends MessageType<ComplianceFrameworkInsight> {
    constructor() {
        super("c1.api.task.v1.ComplianceFrameworkInsight", [
            { no: 1, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ComplianceFrameworkInsight
 */
export const ComplianceFrameworkInsight = new ComplianceFrameworkInsight$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantOriginInsight$Type extends MessageType<GrantOriginInsight> {
    constructor() {
        super("c1.api.task.v1.GrantOriginInsight", [
            { no: 1, name: "grant_reason", kind: "message", T: () => GrantReason }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.GrantOriginInsight
 */
export const GrantOriginInsight = new GrantOriginInsight$Type();
